import React from 'react';
import PropTypes from 'prop-types';
import baseColumns from './archive-grid-columns';
import style from '../style.module.less';

const HeaderRowItem = ({ column }) => <div className={style['header-cell']}>{column.getMessageDescriptor()}</div>;

HeaderRowItem.propTypes = {
  column: PropTypes.shape({
    getMessageDescriptor: PropTypes.func,
    id: PropTypes.string,
    render: PropTypes.func,
  }).isRequired,
};

const HeaderRow = () => (
  <div className={style['archive-header']}>
    {baseColumns.map((column) => (
      <HeaderRowItem key={column.id} column={column} />
    ))}
  </div>
);

export default HeaderRow;
